module.exports = __webpack_public_path__ + "static/media/36-5.c299ffdc.mp3";